import { render, staticRenderFns } from "./nxMobileAudioRecorder.vue?vue&type=template&id=072a230c&scoped=true&"
import script from "./nxMobileAudioRecorder.vue?vue&type=script&lang=js&"
export * from "./nxMobileAudioRecorder.vue?vue&type=script&lang=js&"
import style0 from "./nxMobileAudioRecorder.vue?vue&type=style&index=0&id=072a230c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a230c",
  null
  
)

export default component.exports